"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTaskReminderValidationDto = exports.RejectDocumentValidationDto = exports.ValidateDocumentValidationDto = exports.SendForValidationValidationDto = exports.ResendDocumentValidationDto = exports.DiffuseDocumentValidationDto = exports.CreateDocumentAclValidationDto = exports.MoveNodeValidationDto = exports.RenameFolderValidationDto = exports.CreateFolderValidationDto = exports.UpdateUserCompanyGroupValidationDto = exports.CreateUserCompanyGroupValidationDto = exports.UpdateUserCompanyValidationDto = exports.InviteUserToCompanyValidationDto = void 0;
const class_validator_1 = require("class-validator");
const enums_1 = require("../enums");
class InviteUserToCompanyValidationDto {
    firstName;
    lastName;
    email;
    role;
}
exports.InviteUserToCompanyValidationDto = InviteUserToCompanyValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le prénom est requis' }),
    (0, class_validator_1.IsString)({ message: 'Le prénom doit être une chaîne de caractères' }),
    __metadata("design:type", String)
], InviteUserToCompanyValidationDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le nom est requis' }),
    (0, class_validator_1.IsString)({ message: 'Le nom doit être une chaîne de caractères' }),
    __metadata("design:type", String)
], InviteUserToCompanyValidationDto.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "L'email est requis" }),
    (0, class_validator_1.IsEmail)({}, { message: "L'email n'est pas valide" }),
    __metadata("design:type", String)
], InviteUserToCompanyValidationDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le rôle est requis' }),
    (0, class_validator_1.IsEnum)(enums_1.UserCompanyRole, { message: 'Le rôle sélectionné est invalide' }),
    __metadata("design:type", String)
], InviteUserToCompanyValidationDto.prototype, "role", void 0);
class UpdateUserCompanyValidationDto {
    role;
    email;
    firstName;
    lastName;
}
exports.UpdateUserCompanyValidationDto = UpdateUserCompanyValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le rôle est requis' }),
    (0, class_validator_1.IsEnum)(enums_1.UserCompanyRole, { message: 'Le rôle sélectionné est invalide' }),
    __metadata("design:type", String)
], UpdateUserCompanyValidationDto.prototype, "role", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)({}, { message: "L'email n'est pas valide" }),
    __metadata("design:type", String)
], UpdateUserCompanyValidationDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: 'Le prénom doit être une chaîne de caractères' }),
    __metadata("design:type", String)
], UpdateUserCompanyValidationDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: 'Le nom doit être une chaîne de caractères' }),
    __metadata("design:type", String)
], UpdateUserCompanyValidationDto.prototype, "lastName", void 0);
class CreateUserCompanyGroupValidationDto {
    name;
}
exports.CreateUserCompanyGroupValidationDto = CreateUserCompanyGroupValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le nom du groupe est requis' }),
    (0, class_validator_1.IsString)({ message: 'Le nom du groupe doit être une chaîne de caractères' }),
    __metadata("design:type", String)
], CreateUserCompanyGroupValidationDto.prototype, "name", void 0);
class UpdateUserCompanyGroupValidationDto {
    name;
    memberIds;
}
exports.UpdateUserCompanyGroupValidationDto = UpdateUserCompanyGroupValidationDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: 'Le nom du groupe doit être une chaîne de caractères' }),
    __metadata("design:type", String)
], UpdateUserCompanyGroupValidationDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateUserCompanyGroupValidationDto.prototype, "memberIds", void 0);
class CreateFolderValidationDto {
    name;
    parentId;
}
exports.CreateFolderValidationDto = CreateFolderValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le nom du dossier est requis' }),
    (0, class_validator_1.IsString)({ message: 'Le nom du dossier doit être une chaîne de caractères' }),
    (0, class_validator_1.MaxLength)(255, { message: 'Le nom du dossier ne peut pas dépasser 255 caractères' }),
    __metadata("design:type", String)
], CreateFolderValidationDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)('4', { message: "L'identifiant du dossier parent n'est pas valide" }),
    __metadata("design:type", String)
], CreateFolderValidationDto.prototype, "parentId", void 0);
class RenameFolderValidationDto {
    name;
}
exports.RenameFolderValidationDto = RenameFolderValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'Le nom du dossier est requis' }),
    (0, class_validator_1.IsString)({ message: 'Le nom du dossier doit être une chaîne de caractères' }),
    (0, class_validator_1.MaxLength)(255, { message: 'Le nom du dossier ne peut pas dépasser 255 caractères' }),
    __metadata("design:type", String)
], RenameFolderValidationDto.prototype, "name", void 0);
class MoveNodeValidationDto {
    targetParentId;
}
exports.MoveNodeValidationDto = MoveNodeValidationDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)('4', { message: "L'identifiant du dossier cible n'est pas valide" }),
    __metadata("design:type", String)
], MoveNodeValidationDto.prototype, "targetParentId", void 0);
class CreateDocumentAclValidationDto {
    actorType;
    actorId;
    permission;
    access;
}
exports.CreateDocumentAclValidationDto = CreateDocumentAclValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Le type d'acteur est requis" }),
    (0, class_validator_1.IsEnum)(enums_1.DocumentAclActorType, { message: "Le type d'acteur est invalide" }),
    __metadata("design:type", String)
], CreateDocumentAclValidationDto.prototype, "actorType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "L'identifiant de l'acteur est requis" }),
    (0, class_validator_1.IsUUID)('4', { message: "L'identifiant de l'acteur n'est pas valide" }),
    __metadata("design:type", String)
], CreateDocumentAclValidationDto.prototype, "actorId", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'La permission est requise' }),
    (0, class_validator_1.IsEnum)(enums_1.DocumentPermission, { message: 'La permission est invalide' }),
    __metadata("design:type", String)
], CreateDocumentAclValidationDto.prototype, "permission", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Le type d'accès est requis" }),
    (0, class_validator_1.IsEnum)(enums_1.DocumentAclAccess, { message: "Le type d'accès est invalide" }),
    __metadata("design:type", String)
], CreateDocumentAclValidationDto.prototype, "access", void 0);
class DiffuseDocumentValidationDto {
    groupIds;
    dueDate;
}
exports.DiffuseDocumentValidationDto = DiffuseDocumentValidationDto;
__decorate([
    (0, class_validator_1.IsArray)({ message: 'Les groupes doivent être un tableau' }),
    (0, class_validator_1.ArrayNotEmpty)({ message: 'Au moins un groupe doit être sélectionné' }),
    (0, class_validator_1.IsUUID)('4', { each: true, message: "L'identifiant du groupe n'est pas valide" }),
    __metadata("design:type", Array)
], DiffuseDocumentValidationDto.prototype, "groupIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)({}, { message: "La date limite n'est pas valide" }),
    __metadata("design:type", String)
], DiffuseDocumentValidationDto.prototype, "dueDate", void 0);
class ResendDocumentValidationDto {
    userCompanyIds;
}
exports.ResendDocumentValidationDto = ResendDocumentValidationDto;
__decorate([
    (0, class_validator_1.IsArray)({ message: 'Les utilisateurs doivent être un tableau' }),
    (0, class_validator_1.ArrayNotEmpty)({ message: 'Au moins un utilisateur doit être sélectionné' }),
    (0, class_validator_1.IsUUID)('4', { each: true, message: "L'identifiant de l'utilisateur n'est pas valide" }),
    __metadata("design:type", Array)
], ResendDocumentValidationDto.prototype, "userCompanyIds", void 0);
class SendForValidationValidationDto {
    validatorIds;
    dueDate;
}
exports.SendForValidationValidationDto = SendForValidationValidationDto;
__decorate([
    (0, class_validator_1.IsArray)({ message: 'Les validateurs doivent être un tableau' }),
    (0, class_validator_1.ArrayNotEmpty)({ message: 'Au moins un validateur doit être sélectionné' }),
    (0, class_validator_1.IsUUID)('4', { each: true, message: "L'identifiant du validateur n'est pas valide" }),
    __metadata("design:type", Array)
], SendForValidationValidationDto.prototype, "validatorIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)({}, { message: "La date limite n'est pas valide" }),
    __metadata("design:type", String)
], SendForValidationValidationDto.prototype, "dueDate", void 0);
class ValidateDocumentValidationDto {
    comment;
}
exports.ValidateDocumentValidationDto = ValidateDocumentValidationDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: 'Le commentaire doit être une chaîne de caractères' }),
    (0, class_validator_1.MaxLength)(1000, { message: 'Le commentaire ne peut pas dépasser 1000 caractères' }),
    __metadata("design:type", String)
], ValidateDocumentValidationDto.prototype, "comment", void 0);
class RejectDocumentValidationDto {
    reason;
}
exports.RejectDocumentValidationDto = RejectDocumentValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'La raison du rejet est requise' }),
    (0, class_validator_1.IsString)({ message: 'La raison du rejet doit être une chaîne de caractères' }),
    (0, class_validator_1.MaxLength)(1000, { message: 'La raison du rejet ne peut pas dépasser 1000 caractères' }),
    __metadata("design:type", String)
], RejectDocumentValidationDto.prototype, "reason", void 0);
class SendTaskReminderValidationDto {
    taskRef;
}
exports.SendTaskReminderValidationDto = SendTaskReminderValidationDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: 'La référence de la tâche est requise' }),
    (0, class_validator_1.IsString)({ message: 'La référence de la tâche doit être une chaîne de caractères' }),
    (0, class_validator_1.MaxLength)(128, { message: 'La référence de la tâche est trop longue' }),
    __metadata("design:type", String)
], SendTaskReminderValidationDto.prototype, "taskRef", void 0);
//# sourceMappingURL=validation.dto.js.map